export const getPreferredName = ({
  firstName,
  lastName = '',
  nickName,
}: {
  firstName: string;
  lastName?: string;
  nickName?: string | null;
}) => `${nickName || firstName} ${lastName}`.trim();
